<!--
  inputmode="none" is used to prevent opening virtual keyboard on focus

  Mainly used for other ScreenReaders like TalkBack where it marks input element as disabled when using readonly.
-->
<ion-input
  aria-haspopup="dialog"
  aria-live="assertive"
  (ionFocus)="setOpen(true)"
  (keypress)="$event.preventDefault(); $event.stopImmediatePropagation()"
  placeholder="Enter a date"
  [attr.id]="instanceId"
  [attr.aria-describedby]="ariaDescribedBy"
  [attr.aria-label]="ariaLabel"
  [attr.aria-labelledby]="ariaLabelledBy"
  value="{{ val ? (val | date: dateDisplayFormat) : '' }}"
  [readonly]="showToggleButton"
  inputmode="none"
/>

<mable-button
  #calendarButton
  *ngIf="showToggleButton"
  aria-haspopup="dialog"
  ariaLabel="Open calendar"
  category="icon-only"
  icon="calendar"
  color="grey-500"
  (onClick)="setOpen(true, true)"
/>

<ion-modal
  [attr.data-testid]="modalDataTestId"
  [attr.trigger]="instanceId"
  [isOpen]="isModalOpen"
  (didDismiss)="setOpen(false)"
>
  <ng-template>
    <ion-datetime
      #mableDate
      presentation="date"
      showDefaultButtons="true"
      size="cover"
      [formControl]="control"
      [min]="min"
      [max]="max"
      [yearValues]="yearValues"
      (ionChange)="writeValue(mableDate.value)"
    >
    </ion-datetime>
  </ng-template>
</ion-modal>
